module.exports = __webpack_public_path__ + "img/新华网_03.2f274830.jpg";